import React from "react";
import Colors from "../theme/colors";
import Metrics from "../theme/metrics";
import styled from "styled-components";

export const Container = styled.section`
    display: flex;
    flex-grow: 1;
    align-items: center;
    color: ${(props) => (props.color ? props.color : Colors.Trust.Black)};
    position: relative;
    overflow: hidden;
    padding: 24px ${Metrics.SidePadding[1]} 24px ${Metrics.SidePadding[1]};
    
    @media screen and (min-width: ${Metrics.Breakpoints.medium}) {
        padding: 60px ${Metrics.SidePadding[2]} 200px ${Metrics.SidePadding[2]}
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: ${(props) => (props.center ? "center" : "")};

  @media screen and (min-width: ${Metrics.Breakpoints.medium}) {
    flex-direction: row;
  }
`;

const Section = ({
  color,
  backgroundColor,
  fullPage,
  children,
  style,
  backgroundImage,
  center,
}) => (
  <Container
    color={color}
    fullPage={fullPage}
    style={style}
  >
    <Inner center={center}>{children}</Inner>
  </Container>
);

export default Section;
